import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const state = {
  isSeanLessShowing: true,
  location: ['108.93962099999999', '34.343147'], //首页用户城市经纬度
  layoutShowing: true, //顶部背景块
  recruitScrollY: 0,
  screenY:0,
  screeuuY:0,
  savehdjhaY:0
}
const mutations = {
  //带参数修改
  changeLayout(state, cound) {
    state.layoutShowing = cound.isShow;
  },
  //页面返回 存入滚动条
  changeRecruitScrollY(state, recruitScrollY) {
    state.recruitScrollY = recruitScrollY
  },
  screenYAll(state, screenY) {
    state.screenY = screenY
  },
  screenSHll(state, screeuuY) {
    state.screeuuY = screeuuY
  },
  savehdjkG(state,savehdjhaY){
    state.savehdjhaY = savehdjhaY
  },
  undetexY(state,undeteY){
    state.undeteY = undeteY
  },
  BrandxY(state,BrandY){
    state.BrandY = BrandY
  },
 classxY(state,classY){
    state.classY = classY
  },
  changjiaY(state,changY){
    state.changY = changY
  },

}

export default new Vuex.Store({
  state,
  mutations,
})



// WEBPACK FOOTER //
// ./src/vuex/store.js